import { render, staticRenderFns } from "./UpdateDnsRecordView.vue?vue&type=template&id=3aa3a792&"
import script from "./UpdateDnsRecordView.vue?vue&type=script&lang=js&"
export * from "./UpdateDnsRecordView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports